import classNames from 'classnames';
import React, { memo } from 'react';
import { useMediaQuery } from 'react-responsive';
import './ListRates.css';
import useListRates from './useListRates';
import useListWRates from './useListWRates';

const Rates = ({ className, sm, ...props }) => {
  const { coins, golds, header } = useListRates();
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 736px)' });
  const combinedClassName = classNames('header-rates', 'gap-8', 'd-flex', isDesktopOrLaptop && 'f-row', className);

  const isSm = Boolean(sm) || !isDesktopOrLaptop;

  return isSm ? (
    <div className={combinedClassName} {...props}>
      <div className="card">
        {header}
        <div className="card-body colored-rows">
          {coins}
          {golds}
        </div>
      </div>
    </div>
  ) : (
    <div className={combinedClassName} {...props}>
      <div className="card">
        {header}
        <div className="card-body colored-rows">{coins}</div>
      </div>
      <div className="card">
        {header}

        <div className="card-body colored-rows">{golds}</div>
      </div>
    </div>
  );
};

const WRates = ({ className, sm, ...props }) => {
  const { coins, golds, header } = useListWRates();
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 736px)' });
  const combinedClassName = classNames('header-rates', 'gap-8', 'd-flex', isDesktopOrLaptop && 'f-row', className);

  const isSm = Boolean(sm) || !isDesktopOrLaptop;

  return isSm ? (
    <div className={combinedClassName} {...props}>
      <div className="card">
        {header}

        <div className="card-body colored-rows">
          {coins}
          {golds}
        </div>
      </div>
    </div>
  ) : (
    <div className={combinedClassName} {...props}>
      <div className="card">
        {header}

        <div className="card-body colored-rows">{coins}</div>
      </div>
      <div className="card">
        {header}

        <div className="card-body colored-rows">{golds}</div>
      </div>
    </div>
  );
};

const ListRates = ({ ws = true, ...props }) => {
  return ws ? <WRates {...props} /> : <Rates {...props} />;
};

export default memo(ListRates);
